import type { TextareaPropTypes } from './type';

import React from 'react';
import { Textarea as CKTextarea } from '@chakra-ui/react';

import { FormControl, FormErrorMessage, FormLabel } from '@/components';

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaPropTypes>(
  ({ error, label, isRequired = false, gap, ...rest }, forwardedRef) => {
    return (
      <FormControl
        isInvalid={Boolean(error)}
        isRequired={isRequired}
        gap={gap}
        display="flex"
        flexDirection={'column'}
      >
        {label && <FormLabel marginBottom="8px">{label}</FormLabel>}
        <CKTextarea mb="5px" ref={forwardedRef} rows={4} {...rest} />
        <FormErrorMessage message={error || ''} />
      </FormControl>
    );
  }
);

Textarea.displayName = 'Textarea';
export default Textarea;
